import { motion } from "framer-motion";

/**
 * Reveal — scroll-triggered fade + subtle rise using framer-motion.
 * Use `<Reveal>...</Reveal>` around any block.
 */
export default function Reveal({ children, delay = 0, y = 24, className = "", once = true }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
